export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_fragment_1.ad91e5c1.jpg";